import { HexagonInputProps } from "@/types/components";
import { WHITE_BUTTON_BORDER_COLOR } from "@/utils/constants";

const HexagonInput: React.FC<HexagonInputProps> = ({ checked, onClick }) => {
  return !checked ?
      <svg
        className="hexagonInput"
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => {
          onClick();
        }}
      >
        <path
          d="M9.25 1.58771C10.3329 0.962498 11.6671 0.962498 12.75 1.58771L19.1423 5.27831C20.2252 5.90353 20.8923 7.05897 20.8923 8.3094V15.6906C20.8923 16.941 20.2252 18.0965 19.1423 18.7217L12.75 22.4123C11.6671 23.0375 10.3329 23.0375 9.25 22.4123L2.8577 18.7217C1.77479 18.0965 1.1077 16.941 1.1077 15.6906V8.3094C1.1077 7.05897 1.77479 5.90353 2.8577 5.27831L9.25 1.58771Z"
          stroke={WHITE_BUTTON_BORDER_COLOR}
        />
      </svg>
    : <svg
        className="hexagonInput"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => {
          onClick();
        }}
      >
        <path
          d="M10 1.1547C11.2376 0.440169 12.7624 0.440169 14 1.1547L20.3923 4.8453C21.6299 5.55983 22.3923 6.88034 22.3923 8.3094V15.6906C22.3923 17.1197 21.6299 18.4402 20.3923 19.1547L14 22.8453C12.7624 23.5598 11.2376 23.5598 10 22.8453L3.6077 19.1547C2.37009 18.4402 1.6077 17.1197 1.6077 15.6906V8.3094C1.6077 6.88034 2.37009 5.55983 3.6077 4.8453L10 1.1547Z"
          fill="#FFCD4C"
        />
        <path
          d="M9 12.7L10.8462 14.5L15 10"
          stroke="#262423"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>;
};
export default HexagonInput;
